module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-30 u-margin-bottom-30"
  }, [_vm._v("\n        Purchase - " + _vm._s(_vm.purchase.description) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "purchase_description",
      "label": "Purchase Description"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.description),
      expression: "purchase.description"
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_description.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "purchase_description",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "purchase_description",
      "name": "purchase_description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_description')
    }
  }, [_vm._v("\n                    The purchase description is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "purchase_date",
      "label": "Initial Purchase Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:purchase_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "purchase_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.updateAgeAtPurchase
    },
    model: {
      value: (_vm.purchase.purchaseDate),
      callback: function($$v) {
        _vm.$set(_vm.purchase, "purchaseDate", $$v)
      },
      expression: "purchase.purchaseDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_date')
    }
  }, [_vm._v("\n                    The purchase date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.purchaseDateValidation
    }
  }, [_vm._v("\n                    The purchase date must be after the date of assumed settlement " + _vm._s(_vm.getClaimInfo('dateOfAssumedSettlement')) + "\n                ")])], 1), _vm._v(" "), (_vm.purchase.type !== 'one') ? _c('control', {
    attrs: {
      "for": "purchase_until",
      "label": "Purchase Until"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.purchaseUntil),
      expression: "purchase.purchaseUntil"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "purchase_until",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "purchaseUntil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.purchaseUntilType]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'retirement'
    }
  }, [_vm._v("Retirement")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'life'
    }
  }, [_vm._v("'But For' Life Expectancy")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'own'
    }
  }, [_vm._v("Enter Own Date")])])]) : _vm._e(), _vm._v(" "), (_vm.purchase.purchaseUntil === 'life' && _vm.purchase.type !== 'one') ? _c('life-expectancy', {
    attrs: {
      "label": "Claimant's 'But For' Life Expectancy",
      "person": _vm.thePerson,
      "index": _vm.index,
      "date": _vm.theDate,
      "assumedSettlement": _vm.getClaimInfo('dateOfAssumedSettlement'),
      "type": "claimant"
    },
    on: {
      "update": _vm.updateLife
    }
  }) : _vm._e(), _vm._v(" "), (_vm.purchase.type !== 'one') ? _c('control', {
    attrs: {
      "for": "purchase_end",
      "label": "Purchase End Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:purchase_end.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "purchase_end",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.purchase.purchaseUntil === 'life'
    },
    on: {
      "input": function($event) {
        return _vm.setPurchase()
      }
    },
    model: {
      value: (_vm.purchase.purchaseEnd),
      callback: function($$v) {
        _vm.$set(_vm.purchase, "purchaseEnd", $$v)
      },
      expression: "purchase.purchaseEnd"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_date')
    }
  }, [_vm._v("\n                    The purchase end date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.purchaseEndDateValidation
    }
  }, [_vm._v("\n                    The purchase end date must be after the purchase date " + _vm._s(_vm.purchase.purchaseDate) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "purchase_multiplicand",
      "label": "Purchase Multiplicand",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.multiplicand),
      expression: "purchase.multiplicand",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_multiplicand.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "purchase_multiplicand",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "purchase_multiplicand",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.multiplicand)
    },
    on: {
      "focus": function($event) {
        _vm.purchase.multiplicand = _vm.purchase.multiplicand || ''
      },
      "blur": [function($event) {
        _vm.purchase.multiplicand = _vm.purchase.multiplicand || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "multiplicand", _vm._n($event.target.value))
      }, _vm.setPurchase]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_multiplicand')
    }
  }, [_vm._v("\n                    The purchase multiplicand is required and has to be greater than 0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "mortality_multiplier",
      "label": "Adjust Multiplier for Mortality?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.mortalityMultiplier),
      expression: "purchase.mortalityMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "mortality_multiplier",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "mortalityMultiplier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setPurchase]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "purchase_type",
      "label": "Purchase Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.type),
      expression: "purchase.type"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "purchase_type",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setPurchaseType]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'one'
    }
  }, [_vm._v("One Off")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'recurring'
    }
  }, [_vm._v("Recurring")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'continuous'
    }
  }, [_vm._v("Continuous")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_purchase",
      "label": "Age at Initial Purchase",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.ageAtPurchase),
      expression: "purchase.ageAtPurchase",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:age_at_purchase.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "age_at_purchase",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "age_at_purchase",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.ageAtPurchase)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "ageAtPurchase", _vm._n($event.target.value))
      }, _vm.updateDateOfPurchase],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_at_purchase')
    }
  }, [_vm._v("\n                    Age at purchase is required and has to be greater than 0\n                ")])], 1), _vm._v(" "), (_vm.purchase.type === 'recurring') ? _c('control', {
    attrs: {
      "label": "Purchase Frequency",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.frequency),
      expression: "purchase.frequency",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_frequency.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "purchase_frequency",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "purchase_frequency",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.frequency)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "frequency", _vm._n($event.target.value))
      }, _vm.setPurchase],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.purchase.type !== 'continuous') ? _c('control', {
    attrs: {
      "for": "resale_option",
      "label": "Is There a Resale Value?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.resaleOption),
      expression: "purchase.resaleOption"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "resale_option",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "resaleOption", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateResaleOption]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), (_vm.purchase.resaleOption) ? _c('control', {
    attrs: {
      "for": "resale_value",
      "label": "Resale Value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.resaleValue),
      expression: "purchase.resaleValue",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:resale_value.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "resale_value",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "resale_value",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.resaleValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "resaleValue", _vm._n($event.target.value))
      }, _vm.setPurchase],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_at_purchase')
    }
  }, [_vm._v("\n                    Resale value is required and has to be greater than 0\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.resaleValueValidation
    }
  }, [_vm._v("\n                    The resale value must be less that the initial purchase multiplicand\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "purchase_total",
      "label": "Total",
      "before-after": "pound",
      "tip-show": _vm.purchase.total > 0,
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "purchase_multiplier",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'purchase',
      "payload": _vm.purchasePayload
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.total),
      expression: "purchase.total",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_total.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "purchase_total",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "min": "1",
      "id": "purchase_total",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.total)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "total", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deletePurchase
    }
  }, [_vm._v("Remove Purchase")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multipliers_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac66b0ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/other-future-losses/FuturePurchase.vue
// module id = 1789
// module chunks = 0